import { render, staticRenderFns } from "./RegiaoCadastroModal.vue?vue&type=template&id=3665a1fe&scoped=true"
import script from "./RegiaoCadastroModal.vue?vue&type=script&lang=js"
export * from "./RegiaoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./RegiaoCadastroModal.vue?vue&type=style&index=0&id=3665a1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665a1fe",
  null
  
)

export default component.exports